webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/* exports provided: app, router, store */
/* exports used: app */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(/*! ./components/App */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_smoothscroll_polyfill__ = __webpack_require__(/*! smoothscroll-polyfill */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_smoothscroll_polyfill__);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });







__WEBPACK_IMPORTED_MODULE_5_smoothscroll_polyfill___default.a.polyfill();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));



/***/ }),
/* 9 */
/* unknown exports provided */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 10 */
/* unknown exports provided */
/* all exports used */
/*!***********************!*\
  !*** ./client/pwa.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/* exports provided: default */
/* exports used: default */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(/*! ../views/Home */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/life',
    beforeEnter: function beforeEnter(to, from, next) {
      // Put the full page url including the protocol http(s) below
      window.location = "https://docs.google.com/presentation/d/1GT2iNiKT-CZBt7_DXmVs4eJgV91JN5vt1H6WT5yvNR8/edit?usp=sharing";
    }
  }]
});

/***/ }),
/* 17 */
/* exports provided: default */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 54);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  count: 0
};

var mutations = {
  INCREMENT: function INCREMENT(state) {
    state.count++;
  },
  DECREMENT: function DECREMENT(state) {
    state.count--;
  }
};

var actions = {
  incrementAsync: function incrementAsync(_ref) {
    var commit = _ref.commit;

    setTimeout(function () {
      commit('INCREMENT');
    }, 200);
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 18 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/About.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var controller = new ScrollMagic.Controller();

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    var _ref;

    TagCanvas.textColour = '#000';
    TagCanvas.textFont = 'Crimson Text';
    TagCanvas.wheelZoom = false;
    TagCanvas.outlineColour = '#ffffff00';
    TagCanvas.activeCursor = 'auto';
    TagCanvas.initial = [0.1, -0.1];
    TagCanvas.noSelect = true;
    TagCanvas.Start('myCanvas');

    var aboutTween = TweenMax.to('.about-outer', 1, { opacity: 1 });
    var scene = new ScrollMagic.Scene((_ref = {
      triggerElement: ".about-outer",
      triggerHook: "onEnter"
    }, _defineProperty(_ref, 'triggerHook', "0.8"), _defineProperty(_ref, 'reverse', false), _ref)).setTween(aboutTween).addTo(controller);
  }
};

/***/ }),
/* 19 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Contact.vue ***!
  \***************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(/*! firebase/app */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(/*! firebase/firestore */ 31);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp({
  apiKey: 'AIzaSyAnxuN_-rIE4aLwZYp1pXBy_PzSU7c6vo0',
  authDomain: 'my-portfolio-53d2a.firebaseapp.com',
  projectId: 'my-portfolio-53d2a'
});

var controller = new ScrollMagic.Controller();
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      name: '',
      email: '',
      message: ''
    };
  },
  mounted: function mounted() {
    var _ref;

    var contactTween = TweenMax.to('.contact-container', 1, { opacity: 1 });
    var contactScene = new ScrollMagic.Scene((_ref = {
      triggerElement: ".contact-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref, 'triggerHook', "0.8"), _defineProperty(_ref, 'reverse', false), _ref)).setTween(contactTween).addTo(controller);
  },

  methods: {
    submit: function submit() {
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();

      // Disable deprecated features
      db.settings({
        timestampsInSnapshots: true
      });

      db.collection("messages").add({
        name: this.name,
        email: this.email,
        message: this.message
      }).then(function (docRef) {
        // console.log("Document written with ID: ", docRef.id);
        document.getElementsByClassName('submit')[0].style.display = 'none';
        document.getElementsByClassName('response')[0].style.display = 'block';
      }).catch(function (error) {
        // console.error("Error adding document: ", error);
      });
    }
  }
};

/***/ }),
/* 20 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Hero.vue ***!
  \************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var scrollController = new ScrollMagic.Controller();

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {

    document.getElementById('navvy').style.opacity = 1;
    document.getElementById('skinny1').style.opacity = 1;
    document.getElementById('skinny2').style.opacity = 1;
    document.getElementById('fat').style.opacity = 1;
  },

  methods: {
    scrollToProject: function scrollToProject(el) {
      return;
      if (el === "fraga-project-container" && window.innerWidth <= 700) {
        var selectedElement = document.getElementsByClassName("projects-container")[0];
        selectedElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      } else {
        var _selectedElement = document.getElementsByClassName(el)[0];
        _selectedElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    }
  }
};

/***/ }),
/* 21 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Landing.vue ***!
  \***************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_circle_menu__ = __webpack_require__(/*! vue-circle-menu */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_circle_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_circle_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
	components: {
		CircleMenu: __WEBPACK_IMPORTED_MODULE_0_vue_circle_menu___default.a
	},
	mounted: function mounted() {
		var lineDrawing = anime({
			targets: '#lineDrawing .lines path',
			strokeDashoffset: [anime.setDashoffset, 0],
			easing: 'easeInOutSine',
			duration: 2800,
			delay: function delay(el, i) {
				return i * 250;
			},
			direction: 'alternate',
			loop: false
		});
		document.getElementById('navvy').style.opacity = 1;
	},

	methods: {
		scrollTo: function scrollTo(el) {
			var contact = document.getElementsByClassName(el)[0];
			contact.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		}
	}
};

/***/ }),
/* 22 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Projects.vue ***!
  \****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var controller = new ScrollMagic.Controller();
/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    var _ref, _ref2, _ref3, _ref4, _ref5, _ref6;

    var headingTween = TweenMax.to('#Layer_2', 1, { opacity: 1 });
    var headingScene = new ScrollMagic.Scene((_ref = {
      triggerElement: "#Layer_2",
      triggerHook: "onEnter"
    }, _defineProperty(_ref, "triggerHook", "0.8"), _defineProperty(_ref, "reverse", false), _ref)).setTween(headingTween).addTo(controller);

    var rightQuickTween = TweenMax.to('.right-quick-project-container', 1, { opacity: 1 });
    var rightQuickScene = new ScrollMagic.Scene((_ref2 = {
      triggerElement: ".right-quick-project-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref2, "triggerHook", "0.8"), _defineProperty(_ref2, "reverse", false), _ref2)).setTween(rightQuickTween).addTo(controller);

    var paperTween = TweenMax.to('.paper-project-container', 1, { opacity: 1 });
    var paperScene = new ScrollMagic.Scene((_ref3 = {
      triggerElement: ".paper-project-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref3, "triggerHook", "0.8"), _defineProperty(_ref3, "reverse", false), _ref3)).setTween(paperTween).addTo(controller);

    var fragaTween = TweenMax.to('.fraga-project-container', 1, { opacity: 1 });
    var fragaScene = new ScrollMagic.Scene((_ref4 = {
      triggerElement: ".fraga-project-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref4, "triggerHook", "0.8"), _defineProperty(_ref4, "reverse", false), _ref4)).setTween(fragaTween).addTo(controller);

    var voyagerTween = TweenMax.to('.voyager-project-container', 1, { opacity: 1 });
    var voyagerScene = new ScrollMagic.Scene((_ref5 = {
      triggerElement: ".voyager-project-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref5, "triggerHook", "0.8"), _defineProperty(_ref5, "reverse", false), _ref5)).setTween(voyagerTween).addTo(controller);

    var agilityTween = TweenMax.to('.agility-project-container', 1, { opacity: 1 });
    var agilityScene = new ScrollMagic.Scene((_ref6 = {
      triggerElement: ".agility-project-container",
      triggerHook: "onEnter"
    }, _defineProperty(_ref6, "triggerHook", "0.8"), _defineProperty(_ref6, "reverse", false), _ref6)).setTween(agilityTween).addTo(controller);
  }
};

/***/ }),
/* 23 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Landing__ = __webpack_require__(/*! ../components/Landing */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Hero__ = __webpack_require__(/*! ../components/Hero */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About__ = __webpack_require__(/*! ../components/About */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects__ = __webpack_require__(/*! ../components/Projects */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact__ = __webpack_require__(/*! ../components/Contact */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Contact__);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Landing: __WEBPACK_IMPORTED_MODULE_0__components_Landing___default.a,
    Hero: __WEBPACK_IMPORTED_MODULE_1__components_Hero___default.a,
    Projects: __WEBPACK_IMPORTED_MODULE_3__components_Projects___default.a,
    About: __WEBPACK_IMPORTED_MODULE_2__components_About___default.a,
    Contact: __WEBPACK_IMPORTED_MODULE_4__components_Contact___default.a
  }
};

/***/ }),
/* 24 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-0178ef56","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Hero.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-0365f1f5","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1a5b4674","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Contact.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-208e75d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Projects.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-358e88eb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Landing.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-57668661","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/About.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-ea0a9626","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./client/components/About.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-57668661","scoped":true,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./About.vue */ 29)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./About.vue */ 18),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-57668661"}!../../~/vue-loader/lib/selector?type=template&index=0!./About.vue */ 49),
  /* scopeId */
  "data-v-57668661",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/components/App.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0365f1f5","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 25)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0365f1f5"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 45),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./client/components/Contact.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1a5b4674","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Contact.vue */ 26)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Contact.vue */ 19),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1a5b4674"}!../../~/vue-loader/lib/selector?type=template&index=0!./Contact.vue */ 46),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/* unknown exports provided */
/* exports used: default */
/*!************************************!*\
  !*** ./client/components/Hero.vue ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0178ef56","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Hero.vue */ 24)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 20),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0178ef56"}!../../~/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 44),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./client/components/Landing.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-358e88eb","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Landing.vue */ 28)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Landing.vue */ 21),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-358e88eb"}!../../~/vue-loader/lib/selector?type=template&index=0!./Landing.vue */ 48),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************!*\
  !*** ./client/components/Projects.vue ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-208e75d6","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Projects.vue */ 27)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Projects.vue */ 22),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-208e75d6"}!../../~/vue-loader/lib/selector?type=template&index=0!./Projects.vue */ 47),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-ea0a9626","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 30)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 23),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-ea0a9626"}!../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 50),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0178ef56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Hero.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-first"
  })
},staticRenderFns: []}

/***/ }),
/* 45 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0365f1f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 46 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a5b4674"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Contact.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_4",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "307.968px",
      "height": "50.507px",
      "viewBox": "0 0 307.968 50.507",
      "enable-background": "new 0 0 307.968 50.507",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M26.485,49.819c-12.681,0-22.956-10.32-21.209-23.238C7.029,13.616,20.051,3.185,32.791,3.185\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162C16.675,32.03,19.885,38.69,29.527,38.69\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC39.588,47.698,36.033,49.819,26.485,49.819z M38.08,38.194c-1.49,0.623-4.831,1.82-8.732,1.82c-10.39,0-14.085-7.33-13.246-13.539\n  \t\tc0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498c-0.955-0.488-4.218-1.803-11.617-1.803\n  \t\tc-12.062,0-24.367,9.919-26.01,22.072C4.966,38.677,14.65,48.494,26.665,48.494c7.366,0,10.964-1.29,12.104-1.803L38.08,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M73.626,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n  \t\tc-12.683,0-21.26-10.704-19.551-23.344C49.479,13.834,60.946,3.185,73.626,3.185z M67.5,48.494\n  \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n  \t\tC47.479,38.425,55.595,48.494,67.5,48.494z M72.251,13.359c7.171,0,11.935,5.99,10.972,13.116\n  \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C58.644,19.346,65.082,13.359,72.251,13.359z\n  \t\t M68.876,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n  \t\tC58.134,32.915,62.482,38.319,68.876,38.319z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M101.919,4.642c0,0,0.25-1.348,1.153-0.511l23.343,21.636l2.956-21.128c0.053-0.378,0.426-0.659,0.752-0.659h9.962\n  \t\tc0.401,0,0.611,0.378,0.573,0.662l-5.911,43.721c0,0-0.246,1.346-1.151,0.512L110.145,27.29l-2.849,21.072\n  \t\tc-0.054,0.4-0.467,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L101.919,4.642z M106.061,47.699l2.948-21.807\n  \t\tc0.178-1.316,1.151-0.513,1.151-0.513l23.45,21.584l5.633-41.66h-8.641l-3.059,21.863c-0.184,1.316-1.152,0.509-1.152,0.509\n  \t\tl-23.337-21.63l-5.632,41.653H106.061z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M146.014,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L146.014,4.642z M155.971,12.724\n  \t\tc0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42H147.25\n  \t\tl-1.003,7.42H155.971z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M221.782,48.113c0,0,0.338,0.911-0.737,0.911H210.34c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314h-15.718l-4.144,8.309\n  \t\tc-0.129,0.258-0.406,0.436-0.682,0.436H176.53c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221\n  \t\tc0.274,0,0.496,0.184,0.558,0.414L221.782,48.113z M200.483,5.304L177.69,47.699h9.26l4.144-8.308\n  \t\tc0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L208.81,5.304H200.483z M206.027,31.536\n  \t\th-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719\n  \t\tC207.021,31.623,206.027,31.536,206.027,31.536z M202.614,19.989l-5.301,10.223h7.923L202.614,19.989z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M250.037,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC263.14,47.698,259.584,49.819,250.037,49.819z M261.631,38.194c-1.49,0.623-4.831,1.82-8.732,1.82\n  \t\tc-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498\n  \t\tc-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913\n  \t\tc7.366,0,10.964-1.29,12.104-1.803L261.631,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "contact-path",
    attrs: {
      "d": "M273.796,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L273.796,4.642z M283.753,12.724\n  \t\tc0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n  \t\tl-1.003,7.42H283.753z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "inny",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "name",
      "value": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "inny",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "email",
      "name": "email",
      "value": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "message",
      "rows": "8",
      "required": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "Send it"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "response"
  }, [_c('p', [_vm._v("Thanks! I'll get back to you soon :)")])])
}]}

/***/ }),
/* 47 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-208e75d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Projects.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-container"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "310.548px",
      "height": "50.507px",
      "viewBox": "0 0 310.548 50.507",
      "enable-background": "new 0 0 310.548 50.507",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M24.377,3.979c10.853,0.254,14.602,7.067,13.637,14.124c-1.871,13.673-16.709,14.608-22.867,14.698l-2.104,15.561\n  \t\tc-0.054,0.4-0.468,0.662-0.752,0.662H2.329c-0.401,0-0.611-0.379-0.573-0.662L7.667,4.642c0.054-0.4,0.467-0.662,0.752-0.662\n  \t\tH24.377z M3.17,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662c6.104-0.044,20.293-0.68,22.031-13.383\n  \t\tc0.875-6.396-2.348-12.559-12.506-12.797H8.902L3.17,47.699z M14.986,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662\n  \t\tc5.693,0,10.933,0.999,10.171,6.494c-0.811,5.85-7.201,6.334-11.905,6.436C15.185,24.867,14.938,24.552,14.986,24.196z\n  \t\t M26.154,18.418c0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C21.229,23.362,25.571,22.62,26.154,18.418z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M62.061,3.979c10.854,0.254,14.602,7.067,13.637,14.124c-0.898,6.561-4.88,10.255-9.392,12.261l9.216,17.633\n  \t\tc0,0,0.589,1.027-0.692,1.027h-10.97c-0.225,0-0.423-0.125-0.514-0.3l-8.313-15.993c-0.872,0.044-1.623,0.062-2.202,0.07\n  \t\tl-2.104,15.561c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L45.35,4.642\n  \t\tc0.054-0.4,0.467-0.662,0.752-0.662H62.061z M40.853,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662\n  \t\tc0.888-0.006,1.971-0.025,3.178-0.096c0.203-0.012,0.446,0.094,0.553,0.299l8.324,16.013h9.383l-9.02-17.26\n  \t\tc-0.318-0.608,0.247-0.903,0.429-0.976c4.475-1.775,8.318-5.027,9.185-11.363c0.875-6.396-2.348-12.559-12.506-12.797H46.585\n  \t\tL40.853,47.699z M52.669,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662c5.692,0,10.933,0.999,10.171,6.494\n  \t\tc-0.811,5.85-7.201,6.334-11.905,6.436C52.868,24.867,52.621,24.552,52.669,24.196z M63.837,18.418\n  \t\tc0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C58.913,23.362,63.254,22.62,63.837,18.418z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M105.699,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n  \t\tc-12.683,0-21.26-10.704-19.551-23.344C81.552,13.834,93.019,3.185,105.699,3.185z M99.573,48.494\n  \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n  \t\tC79.552,38.425,87.667,48.494,99.573,48.494z M104.324,13.359c7.171,0,11.935,5.99,10.972,13.116\n  \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C90.716,19.346,97.155,13.359,104.324,13.359z\n  \t\t M100.949,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n  \t\tC90.207,32.915,94.555,38.319,100.949,38.319z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M155.584,36.015c-1.207,8.928-7.106,13.805-16.148,13.805c-6.29,0-11.691-0.532-11.704-0.533\n  \t\tc-0.16-0.016-0.792-0.131-0.447-0.869l4.469-9.539c0.139-0.296,0.469-0.482,0.765-0.448c0,0,4.528,0.526,7.008,0.526\n  \t\tc2.491,0,4.556-1.359,5.113-5.485l3.898-28.829c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662\n  \t\tL155.584,36.015z M149.774,5.304l-3.808,28.167c-0.632,4.671-3.386,6.81-6.618,6.81c-2.082,0-5.337-0.334-6.631-0.476l-3.858,8.235\n  \t\tc1.66,0.139,5.99,0.454,10.756,0.454c8.446,0,13.53-4.238,14.645-12.479l4.152-30.711H149.774z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M190.549,13.386c-0.054,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.401,0,0.611,0.377,0.573,0.662\n  \t\tl-1.182,8.744c-0.054,0.4-0.468,0.662-0.752,0.662h-13.751l-1.01,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.4-0.468,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.054-0.4,0.468-0.662,0.752-0.662\n  \t\th25.013c0.401,0,0.611,0.378,0.573,0.662L190.549,13.386z M166.629,5.304l-5.732,42.396h23.688l1.003-7.419H171.2\n  \t\tc-0.284,0-0.627-0.262-0.573-0.662l1.189-8.797c0.039-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419h-13.752\n  \t\tc-0.284,0-0.627-0.262-0.573-0.662l1.175-8.691c0.039-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H166.629z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M215.383,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC228.486,47.698,224.931,49.819,215.383,49.819z M226.978,38.194c-1.49,0.623-4.831,1.82-8.732,1.82\n  \t\tc-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498\n  \t\tc-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913\n  \t\tc7.366,0,10.964-1.29,12.104-1.803L226.978,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M239.142,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L239.142,4.642z M249.099,12.724\n  \t\tc0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n  \t\tl-1.003,7.42H249.099z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M288.717,38.754c2.567,0.009,4.146-0.86,4.451-3.11c0.808-5.975-17.135-7.705-15.683-18.441\n  \t\tc0.321-2.373,1.267-4.766,2.757-6.89c4.75-6.772,14.868-10.593,27.378-2.908c0.291,0.179,0.332,0.586,0.146,0.876l-5.103,7.949\n  \t\tc-0.053,0.082-0.475,0.77-1.053,0.199c-2.221-2.189-4.748-3.016-6.981-3.022c-3.396-0.011-5.803,1.827-6.019,3.425\n  \t\tc-0.492,3.639,18.605,5.455,16.878,18.229c-0.357,2.642-1.609,5.269-3.521,7.554c-6.126,7.322-18.985,11.114-31.629,1.309\n  \t\tc-0.254-0.197-0.284-0.588-0.07-0.881l6.114-8.373c0.211-0.29,0.642-0.465,0.978-0.203\n  \t\tC280.314,36.762,285.167,38.742,288.717,38.754z M271.704,43.187c12.156,9.088,24.001,5.168,29.433-1.517\n  \t\tc1.659-2.042,2.719-4.338,3.026-6.609c1.569-11.604-17.681-12.29-16.878-18.229c0.374-2.766,3.84-4.762,7.527-4.75\n  \t\tc2.361,0.008,4.899,0.792,7.224,2.811l4.264-6.643c-11.968-7.066-20.988-3.16-25.108,2.881c-1.284,1.883-2.102,3.992-2.383,6.072\n  \t\tc-1.256,9.293,16.75,10.552,15.684,18.441c-0.436,3.221-3.088,4.444-5.959,4.436c-3.753-0.013-8.391-1.868-11.546-4.129\n  \t\tL271.704,43.187z"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-project-container clearfix"
  }, [_c('h3', [_vm._v("Paper")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Paper is a financial news PWA which allows the user to follow companies listed on the NASDAQ. Up to five companies can be selected at once, with their 1 month historical prices charted, and the news feed customised to only return news pertaining to these shares.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with React and React Router. State and API calls are managed with Redux. The site is optimised as a PWA using webpack-pwa-plugin and service workers. The live project is hosted on Netlify.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/investment-app"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://paper-app.netlify.com/#/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fdsf_xcrdjz.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voyager-project-container clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('h3', [_vm._v("Outer Step")]), _vm._v(" "), _c('div', {
    staticClass: "right-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Outer Step is an Australian music festival. I built this website as a freelance developer to serve as a marketing and ticket sales platform. The site is optimised for fast loading times across browsers, while rich in assets and animations.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project its built with Vue and hosted on Firebase. \n      It is integrated with Humanitix for ticket sales and Soundcloud for artist music samples.\n      Scroll animations were built using ScrollMagic and TweenMax.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://outer-step-staging.firebaseapp.com/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "left",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/outer_dswnet.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-quick-project-container clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('h3', [_vm._v("Right Quick")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Right Quick is a game to test your typing\n      skills with your right hand. I built this primarily as a rehabilitation\n      tool for people recoving from a stroke.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Vue. It uses VueX,\n      ChartJS, and string-similarity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/rightQuickTyping"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://andthomas.github.io/rightQuickTyping/#/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/rightgif_gykgyc.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fraga-project-container clearfix"
  }, [_c('h3', [_vm._v("Fråga")]), _vm._v(" "), _c('div', {
    staticClass: "right-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Fråga is the Swedish word for 'Ask'. The\n      project is a location based social media platform, where posts are\n      pinned to a specific location and can be commented on by people in that\n      area.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Ruby on Rails.\n      Locations are detected by device and geocoded to a Google map.\n      Translations are handled with Yandex.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/aparkinbotswana/Fraga"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fraqa.herokuapp.com/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "left",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fraggif_g9qit0.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agility-project-container clearfix"
  }, [_c('h3', [_vm._v("Agility")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Agility is a retro styled game for the browser, inspired by Pong and Frogger. I built this in order to \n      try out a few new ES6 features including class syntax, destructuring and new array methods.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Vanilla JS, HTML and CSS.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/agility"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://andthomas.github.io/agility/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/agility_zt6vzf.gif",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 48 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-358e88eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Landing.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "lineDrawing"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "800px",
      "height": "200px",
      "viewBox": "0 0 600 150",
      "enable-background": "new 0 0 600 150",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    staticClass: "lines"
  }, [_c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M61.368,113.985c-0.096,0.702-0.82,1.161-1.32,1.161h-17.48c-0.702,0-1.072-0.663-1.004-1.161l3.839-28.407H27.458\n\t\t\t\tl-3.84,28.407c-0.095,0.702-0.82,1.161-1.319,1.161H4.818c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.094-0.704,0.819-1.163,1.319-1.163h17.48c0.703,0,1.072,0.663,1.005,1.163l-3.853,28.498h17.945l3.853-28.498\n\t\t\t\tc0.095-0.704,0.821-1.163,1.32-1.163h17.479c0.705,0,1.073,0.663,1.006,1.163L61.368,113.985z M54.103,38.438l-3.854,28.499\n\t\t\t\tc-0.066,0.499-0.615,1.162-1.319,1.162H28.66c-0.499,0-1.1-0.458-1.005-1.162l3.853-28.499H16.352L6.295,112.824h15.156\n\t\t\t\tl3.84-28.406c0.068-0.499,0.616-1.163,1.32-1.163h20.271c0.499,0,1.1,0.459,1.004,1.163l-3.84,28.406h15.156l10.057-74.386H54.103z\n\t\t\t\t"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M92.789,113.985c-0.095,0.702-0.821,1.161-1.319,1.161h-17.48c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.095-0.704,0.82-1.163,1.319-1.163h17.481c0.703,0,1.072,0.663,1.004,1.163L92.789,113.985z M85.522,38.438l-10.058,74.386\n\t\t\t\th15.156l10.057-74.386H85.522z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M109.025,111.695c-0.787,5.815-5.498,10.392-9.655,13.491c-0.322,0.241-0.744,0.198-0.956,0.002l-2.04-1.89\n\t\t\t\tc-0.211-0.196-0.425-0.669,0.11-1.122c0,0,2.524-2.178,3.761-5.246c-2.047-0.807-3.362-2.744-3.025-5.235\n\t\t\t\tc0.445-3.289,3.429-5.925,6.681-5.925C107.193,105.771,109.47,108.403,109.025,111.695z M98.72,111.695\n\t\t\t\tc-0.271,2.003,0.902,3.526,2.758,3.996c0.342,0.087,0.572,0.468,0.44,0.87c-0.947,2.888-2.814,5.007-3.888,6.085l1.064,0.986\n\t\t\t\tc3.832-2.951,7.772-7.075,8.43-11.938c0.333-2.468-1.358-4.425-3.827-4.425C101.28,107.271,99.054,109.224,98.72,111.695z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M145.646,113.985c-0.095,0.702-0.821,1.161-1.32,1.161h-17.48c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.094-0.704,0.819-1.163,1.319-1.163h17.48c0.704,0,1.073,0.663,1.005,1.163L145.646,113.985z M138.38,38.438l-10.058,74.386\n\t\t\t\th15.156l10.056-74.386H138.38z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M172.296,36.116c0.384,0,0.744,0.298,0.64,0.803l-3.457,16.739c-0.085,0.413-0.505,0.697-0.842,0.697h-5.569\n\t\t\t\tc-0.415,0-0.676-0.361-0.654-0.697l1.07-16.739c0.024-0.383,0.35-0.803,0.856-0.803H172.296z M163.969,52.855h4.172l3.147-15.24\n\t\t\t\th-6.345L163.969,52.855z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M208.537,114.681c-0.48,0-0.87-0.319-0.979-0.725l-11.544-42.723l-6.026,42.758c-0.093,0.662-0.749,1.155-1.318,1.155\n\t\t\t\th-17.388c-0.703,0-1.072-0.663-1.005-1.161l10.372-76.709c0.095-0.704,0.821-1.163,1.32-1.163h24.732\n\t\t\t\tc0.481,0,0.877,0.317,0.983,0.744l10.415,41.439l21.446-41.435c0.232-0.451,0.725-0.748,1.186-0.748h24.826\n\t\t\t\tc0.704,0,1.073,0.663,1.006,1.163l-10.373,76.709c-0.095,0.702-0.82,1.161-1.319,1.161h-17.387c-0.662,0-1.082-0.582-1.006-1.157\n\t\t\t\tl5.621-42.78l-23.276,42.751c-0.241,0.444-0.741,0.72-1.173,0.72H208.537z M243.015,64.916c0.713-1.311,2.178,0.437,2.178,0.437\n\t\t\t\tl-6.236,47.472h15.067l10.058-74.386h-22.865L218.698,81.95c-1.089,2.103-2.17,0.003-2.17,0.003L205.59,38.438h-22.774\n\t\t\t\tl-10.058,74.386h15.07l6.691-47.475c0.199-1.414,2.297-0.43,2.297-0.43l12.818,47.438h7.549L243.015,64.916z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "id": "letter-a",
      "d": "M360.663,113.549c0,0,0.595,1.598-1.293,1.598h-18.782c-0.481,0-0.88-0.312-0.984-0.753l-3.511-14.589h-27.577\n\t\t\t\tl-7.271,14.577c-0.227,0.455-0.713,0.765-1.195,0.765h-18.782c0,0-1.802,0.151-0.863-1.596l41.242-76.709\n\t\t\t\tc0.239-0.446,0.737-0.728,1.176-0.728h16.18c0.48,0,0.87,0.322,0.979,0.727L360.663,113.549z M323.293,38.438l-39.992,74.386\n\t\t\t\th16.248l7.27-14.578c0.229-0.454,0.714-0.766,1.198-0.766h29.195c0.469,0,0.877,0.302,0.985,0.753l3.51,14.591h16.253\n\t\t\t\tl-20.057-74.386H323.293z M333.021,84.463h-17.292c-1.856,0-0.874-1.58-0.874-1.58l11.571-22.313\n\t\t\t\tc1.091-2.102,2.169-0.007,2.169-0.007l5.723,22.314C334.764,84.616,333.021,84.463,333.021,84.463z M327.032,64.203l-9.301,17.935\n\t\t\t\th13.901L327.032,64.203z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M379.933,37.276c0,0,0.438-2.366,2.024-0.898l40.955,37.961l5.186-37.068c0.095-0.663,0.747-1.157,1.319-1.157h17.481\n\t\t\t\tc0.702,0,1.07,0.663,1.005,1.163l-10.372,76.709c0,0-0.43,2.361-2.021,0.897l-41.144-37.869l-4.999,36.972\n\t\t\t\tc-0.096,0.702-0.821,1.161-1.321,1.161h-17.479c-0.703,0-1.072-0.663-1.006-1.161L379.933,37.276z M387.2,112.824l5.173-38.264\n\t\t\t\tc0.312-2.308,2.021-0.898,2.021-0.898l41.145,37.87l9.883-73.094h-15.16l-5.367,38.361c-0.324,2.308-2.021,0.891-2.021,0.891\n\t\t\t\tl-40.947-37.951l-9.882,73.085H387.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M482.501,36.113c21.613,0,37.52,16.492,34.413,39.47c-3.118,23.068-23.39,39.563-45.099,39.563h-22.316\n\t\t\t\tc-0.703,0-1.071-0.663-1.006-1.161l10.372-76.709c0.096-0.704,0.821-1.163,1.32-1.163H482.501z M450.975,112.824h21.155\n\t\t\t\tc20.503,0,39.52-15.492,42.459-37.241c2.927-21.652-11.991-37.145-32.403-37.145h-21.15L450.975,112.824z M469.093,99.527\n\t\t\t\tc-0.499,0-1.101-0.46-1.005-1.164l6.146-45.467c0.068-0.499,0.617-1.162,1.318-1.162c19.456,0,24.534,10.065,22.659,23.943\n\t\t\t\tC496.334,89.557,488.541,99.527,469.093,99.527z M476.4,54.071l-5.83,43.119c17.445-0.389,23.609-8.885,25.317-21.512\n\t\t\t\tC497.604,62.993,493.622,54.459,476.4,54.071z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M591.781,36.113c0,0,2.119-0.133,0.768,1.748l-33.596,46.777l-3.968,29.348c-0.095,0.702-0.821,1.161-1.319,1.161h-19.992\n\t\t\t\tc-0.702,0-1.072-0.663-1.004-1.161l3.969-29.349l-20.855-46.777c0,0-0.936-1.746,1.241-1.746h20.549\n\t\t\t\tc0.432,0,0.798,0.276,0.933,0.593l12.076,28.312l19.553-28.307c0.264-0.378,0.729-0.598,1.097-0.598H591.781z M551.204,67.965\n\t\t\t\tc-1.341,1.944-2.029,0.005-2.029,0.005l-12.596-29.532h-17.85l20.197,45.301c0.077,0.175,0.104,0.381,0.078,0.585l-3.853,28.5\n\t\t\t\th17.665l3.854-28.5c0.027-0.203,0.108-0.409,0.236-0.585l32.535-45.301h-17.842L551.204,67.965z"
    }
  })])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "navvy"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas"
    }
  }, [_c('i', {
    staticClass: "fab fa-github"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.linkedin.com/in/andy-t-brown/"
    }
  }, [_c('i', {
    staticClass: "fab fa-linkedin-in"
  })])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "menu"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("(There's not much here, come see by "), _c('a', {
    attrs: {
      "href": "https://blog.andybrown.dev/"
    }
  }, [_vm._v("blog")]), _vm._v(")")])
}]}

/***/ }),
/* 49 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-57668661"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/About.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-outer"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_3",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "310.29px",
      "height": "48.58px",
      "viewBox": "0 0 310.29 48.58",
      "enable-background": "new 0 0 310.29 48.58",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    staticClass: "lines"
  }, [_c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M46.574,45.993c0,0,0.338,0.911-0.737,0.911H35.132c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314H16.852l-4.144,8.309\n    \t\tc-0.129,0.258-0.406,0.436-0.682,0.436H1.322c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221\n    \t\tc0.274,0,0.496,0.184,0.558,0.414L46.574,45.993z M25.274,3.184L2.481,45.579h9.26l4.144-8.308\n    \t\tc0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L33.601,3.184H25.274z M30.819,29.416\n    \t\th-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719\n    \t\tC31.812,29.503,30.819,29.416,30.819,29.416z M27.405,17.869l-5.301,10.223h7.923L27.405,17.869z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M85.644,33.947c-1.161,8.582-8.684,12.957-17.412,12.957H51.804c-0.401,0-0.611-0.379-0.573-0.662l5.882-43.508\n    \t\tc0.054-0.401,0.468-0.663,0.752-0.663h16.428c8.803,0,13.603,4.63,12.456,13.116c-0.483,3.57-2.098,6.586-4.439,8.775\n    \t\tC84.95,26.297,86.224,29.656,85.644,33.947z M80.901,23.553c2.406-1.988,4.043-4.816,4.523-8.365\n    \t\tc1.045-7.73-3.049-11.791-11.31-11.791H58.349l-5.703,42.183h15.766c8.336,0,14.875-3.999,15.907-11.632\n    \t\tc0.567-4.193-0.802-7.31-3.483-9.366C80.267,24.146,80.761,23.668,80.901,23.553z M64.902,27.244h1.272\n    \t\tc1.988,0,9.705,0.141,8.904,6.066c-0.79,5.845-6.716,6.068-10.545,6.068h-1.272c-0.284,0-0.627-0.262-0.573-0.662l1.462-10.811\n    \t\tC64.188,27.621,64.501,27.244,64.902,27.244z M64.103,38.055h0.609c4.12,0,8.441-0.307,9.041-4.744\n    \t\tc0.589-4.354-5.401-4.742-7.758-4.742h-0.609L64.103,38.055z M65.053,21.229l1.461-10.811c0.039-0.284,0.351-0.662,0.752-0.662\n    \t\th1.272c3.916,0,8.248,0.338,7.473,6.067s-5.198,6.067-9.114,6.067h-1.272C65.341,21.891,64.999,21.629,65.053,21.229z\n    \t\t M67.077,20.566c4.033,0,6.995-0.192,7.61-4.743s-2.294-4.743-6.328-4.743H67.75l-1.283,9.486H67.077z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M118.206,1.064c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n    \t\tc-12.683,0-21.26-10.704-19.551-23.344C94.059,11.714,105.525,1.064,118.206,1.064z M112.08,46.374\n    \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n    \t\tC92.059,36.305,100.174,46.374,112.08,46.374z M116.831,11.239c7.171,0,11.935,5.99,10.972,13.116\n    \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C103.223,17.226,109.662,11.239,116.831,11.239z\n    \t\t M113.456,36.199c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n    \t\tC102.713,30.795,107.062,36.199,113.456,36.199z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M177.901,30.715c-1.508,11.153-8.605,16.984-20.023,16.984s-16.938-5.831-15.43-16.984l3.812-28.193\n    \t\tc0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662L154.13,27.8c-0.965,7.134,0.759,8.771,5.252,8.771\n    \t\tc4.495,0,6.66-1.637,7.625-8.771l3.417-25.278c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662\n    \t\tL177.901,30.715z M171.661,3.184L168.333,27.8c-1.013,7.493-3.872,10.095-9.128,10.095c-5.257,0-7.412-2.603-6.399-10.095\n    \t\tl3.328-24.616h-8.638l-3.722,27.531c-1.416,10.467,3.444,15.659,14.284,15.659c10.839,0,17.104-5.192,18.519-15.659l3.723-27.531\n    \t\tH171.661z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M186.831,2.521c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n    \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n    \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L186.831,2.521z M196.788,10.604\n    \t\tc0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n    \t\tl-1.003,7.42H196.788z"
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-container"
  }, [_c('div', {
    staticClass: "lefty"
  }, [_c('p', [_vm._v("\n          Born and raised in Sydney, Australia, I'm a web developer with a passion\n          for intuitive design and front-end development.\n          "), _c('br'), _c('br'), _vm._v("\n          Outside of work I love listening to podcasts from RadioLab, This\n          American Life and Syntax as well as riding my motorbike around the\n          streets of Sydney.\n          "), _c('br'), _c('br'), _vm._v("\n          My background is in the fast-paced agency world as a\n          developer and project manager. I've also worked as a teachers\n          assistant for General Assembly's Front End Web Development course, and as\n\t\t\t\t\ta freelance developer.\n          "), _c('br'), _c('br'), _vm._v("\n          I'm at my best when I'm working on the front-end, but I'm also\n          comfortable working with Ruby on Rails, PHP/Laravel as well as\n          PHP/Wordpress. I absolutely love working with VueJS. It's my go to\n          framework for the bulk of my professional projects as well as personal\n          ones.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "righty"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "myCanvasContainer"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "width": "500",
      "height": "400",
      "id": "myCanvas"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("HTML/CSS:"), _c('br'), _vm._v(" Less, Sass")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Javascript: "), _c('br'), _vm._v("Vanilla JS, "), _c('br'), _vm._v("ES6, JQuery")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("VueJS:"), _c('br'), _vm._v(" Vue Router, Vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Firebase Suite")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Wordpress")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Photoshop")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Ruby on Rails")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Git")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Yarn")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("NPM")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("MAMP")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("RESTful APIs")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Sketch")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Webpack")])])])])])])])
}]}

/***/ }),
/* 50 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea0a9626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('landing'), _vm._v(" "), _c('hero')], 1)
},staticRenderFns: []}

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/* unknown exports provided */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 8);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(/*! ./pwa */ 10);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[56]);


// WEBPACK FOOTER //
// client.10dd141a.js